// extracted by mini-css-extract-plugin
export var block = "Hero-module--block--QCWVt";
export var imgWrap = "Hero-module--imgWrap--OGzJ+";
export var img = "Hero-module--img--RLyEy";
export var bottom = "Hero-module--bottom--fOQQ-";